import { Box, useTheme } from '@mui/material'
import React, { ReactNode } from 'react'
import { useStyles } from './styles'

export type RectangleProps = {
    padding?: number
    children: ReactNode
}

export const Rectangle = ({ padding = 2, children }: RectangleProps): React.ReactElement => {
    const theme = useTheme()
    const classes = useStyles(theme)

    return (
        <Box p={padding} className={classes.rectangle} flexWrap="wrap">
            {children}
        </Box>
    )
}
